<template>
  <section class="footer-component">
    <div class="footer-container">
      <div class="copyright">
        @ 2019 绿展集团 <a class="icp" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备18093034号</a>
      </div>
      <div class="social-links"><router-link :to="{name: 'Cert'}">ISO证书</router-link></div>
      <div class="social-links">
       <!--  <div class="mobile-hide">访问 <a href="http://www.greenprosperitygroup.com" target="_blank">www.greenprosperitygroup.com</a></div>
        <div class="desktop-hide">访问<a href="http://www.greenprosperitygroup.com" target="_blank">.com</a></div> -->
        <div><a href="mailto:inquiry@greenprosperitygroup.com"><img src="../assets/mail.png"></a></div>
        <router-link :to="{name: 'Legal'}">法律</router-link>
      </div>
    </div>
  </section>
</template>
<style lang="scss">
  .footer-component {
    background-color: #454545;
    color: #fdfdfd;
    .footer-container {
      width: 95%;
      height: 4.2vw;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    font-size: 0.8vw;
  }
  .copyright {
    width: 25vw;
    height: 2vw;
    line-height: 2vw;
    .icp {
      padding-left: 1vw;
      display: inline-block;
      color: #fff;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .social-links {
    width: 22vw;
    height: 3vw;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .social-links a {
    display: inline-block;
    color: #fdfdfd;
    img {
      width: 1.2vw;
      height: 1.2vw;
    }
  }
  .social-links a:hover {
    text-decoration: underline;
  }
  // mobile style
  @media (max-width: 1024px) {
    .footer-component {
       font-size: 2.3vw;
       .footer-container {
         height: 10vw;
       }
       .copyright {
         width:70vw;
         line-height: 3vw;
         height: auto;
         .icp {
           padding-left: 0;
           font-size: 2.3vw;
         }
       }
       .social-links {
         width: 25vw;
         .desktop-hide a {
           font-family: 'Avenir-Black';
         }
         img {
          width: 3.2vw;
          height: 3.2vw;
        }
       }
    }
  }
</style>
<script>
export default {
  props: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue